export default __webpack_public_path__ + "static/media/BTSTU KIT - SNARE1.60606984.wav";